export default {
  createSchema: {
    en: 'Create Schema',
    zh: '创建模式',
  },
  editSchema: {
    en: 'Edit Schema',
    zh: '编辑模式',
  },
  addSchema: {
    en: 'Add Schema',
    zh: '添加模式',
  },
  schemaName: {
    en: 'Schema Name',
    zh: '模式名称',
  },
  file: {
    en: 'File',
    zh: '文件',
  },
  content: {
    en: 'Content',
    zh: '内容',
  },
  schemaType: {
    en: 'Schema Type',
    zh: '模式类型',
  },
  detailSchema: {
    en: 'Schema Detail',
    zh: '模式详情',
  },
  binaryFile: {
    en: 'Schema Binary File(*.so)',
    zh: '模式二进制文件（*.so）',
  },
  schemaContent: {
    en: 'Schema Content',
    zh: '模式内容',
  },
}
